import { generateUniqueId } from '../../helpers/common';

export const GET_FIND_REALTIME_FIELDS_SUCCESS = generateUniqueId();
export const GET_FIND_REALTIME_FIELDS_REQUEST = generateUniqueId();
export const GET_FIND_REALTIME_FIELDS_FAILURE = generateUniqueId();

export const REMOVE_FIELDS_FROM_SELECTIONS = generateUniqueId();
export const CLEAR_FIELDS_SELECTIONS = generateUniqueId();

export const SELECT_FIELDS = generateUniqueId();
export const RESET_SELECT_FIELDS = generateUniqueId();
export const SELECT_FIELDS_INDEX = generateUniqueId();
export const ADD_FIELDS_TO_SELECTIONS = generateUniqueId();